const MOUTH_PATH = {
  idle: 'M42 37 Q50 41 58 37',
  thinking: 'M44 38 Q50 37 56 38',
  talking: 'M42 35 Q50 44 58 35',
};

/**
 * Tiny animated 2D avatar for the chatbox — CSS/SVG only, no external animation
 * library. `state` drives body/mouth pose ('idle' | 'thinking' | 'talking');
 * `mouthOpen` (only meaningful in 'talking' state) lets a later phase toggle the
 * mouth per word-boundary event instead of the built-in looping animation.
 */
export default function AgentCharacter({ state = 'idle', mouthOpen, size = 40 }) {
  const bodyAnim = state === 'thinking'
    ? 'animate-[agent-think-tilt_2.2s_ease-in-out_infinite]'
    : 'animate-[agent-breathe_3.2s_ease-in-out_infinite]';
  const mouthPath = MOUTH_PATH[state] || MOUTH_PATH.idle;
  let mouthStyle = { transformOrigin: '50% 37%' };
  if (state === 'talking') {
    mouthStyle = mouthOpen === undefined
      ? { ...mouthStyle, animation: 'agent-mouth-talk 0.32s ease-in-out infinite' }
      : { ...mouthStyle, transform: mouthOpen ? 'scaleY(1)' : 'scaleY(0.4)' };
  }

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} aria-hidden="true">
      <svg viewBox="0 0 100 100" width={size} height={size} className={bodyAnim} style={{ transformOrigin: '50% 100%' }}>
        <rect x="8" y="60" width="14" height="8" rx="4" fill="var(--color-primary-500)" />
        <rect x="78" y="60" width="14" height="8" rx="4" fill="var(--color-primary-500)" />
        <rect x="20" y="50" width="60" height="46" rx="20" fill="var(--color-primary-500)" />
        <line x1="50" y1="12" x2="50" y2="5" stroke="var(--color-primary-400)" strokeWidth="3" />
        <circle cx="50" cy="5" r="3" fill="var(--color-primary-300)" />
        <circle cx="50" cy="30" r="18" fill="var(--color-primary-400)" />
        <g className="animate-[agent-blink_4.6s_ease-in-out_infinite]" style={{ transformOrigin: '50% 29%' }}>
          <circle cx="42" cy="29" r="3" fill="white" />
          <circle cx="58" cy="29" r="3" fill="white" />
        </g>
        <path d={mouthPath} stroke="white" strokeWidth="3" strokeLinecap="round" fill="none" style={mouthStyle} />
        {state === 'thinking' && (
          <g fill="var(--color-primary-300)">
            <circle cx="70" cy="14" r="2.4" className="animate-[agent-think-dot_1.2s_ease-in-out_infinite]" style={{ animationDelay: '0s' }} />
            <circle cx="78" cy="9" r="2.2" className="animate-[agent-think-dot_1.2s_ease-in-out_infinite]" style={{ animationDelay: '0.2s' }} />
            <circle cx="86" cy="5" r="2" className="animate-[agent-think-dot_1.2s_ease-in-out_infinite]" style={{ animationDelay: '0.4s' }} />
          </g>
        )}
      </svg>
    </div>
  );
}
